import Breadcrumb from './src/breadcrumb.vue'
import BreadcrumbItem from './src/breadcrumb-item.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToBreadcrumb: SFCWithInstall<typeof Breadcrumb> = withInstall(Breadcrumb)
export const ToBreadcrumbItem: SFCWithInstall<typeof BreadcrumbItem> = withInstall(BreadcrumbItem)

export * from './src/instance'
